import Schema from 'AppReact/schema';
import { orderEvent, personToMention } from 'types';

export default {
  event: Schema(orderEvent, 'object', { defaultValue: Schema(orderEvent).sampleData() }),
  currentUser: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  acceptDocuments: Schema('boolean', 'primitive', { defaultValue: false }),
  personsToMention: Schema(personToMention, 'array', { defaultValue: [] }),
  displayBottom: Schema('boolean', 'primitive', { defaultValue: false }),
}